'use client';

import { AlertCircle } from 'lucide-react';

export function ErrorAlert({ message }: { message: string }) {
  if (!message) return null;

  return (
    <div className="mb-6 p-3 bg-red-50 border border-red-100 rounded-xl text-red-600 text-sm flex items-center gap-2">
      <AlertCircle className="w-4 h-4 flex-shrink-0" />
      <span>{message}</span>
    </div>
  );
}
